export const weekdays = {
  sunday: 'sunday',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
};

export const weekdaysValueList = Object.keys(weekdays).map(weekday => weekdays[weekday]);
